import React from 'react'

interface Props{
  handleAsoleacionImagesCount: any,
  asoleacionCurrentSetIndex: number,
  isAsoleacionModalOpened: boolean,
  asoleacionCurrentSet: any
}

interface State{
  currentAsoleacionSet: any,
  currentIndex: any
}

class AsoleacionImages extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentAsoleacionSet: [],
      currentIndex: 0
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
      if(prevState.currentAsoleacionSet !== this.state.currentAsoleacionSet && this.state.currentAsoleacionSet.length > 0){
        this.props.handleAsoleacionImagesCount()
      }
      if(this.props.asoleacionCurrentSet !== prevProps.asoleacionCurrentSet){
        this.setState({
          currentAsoleacionSet: this.props.asoleacionCurrentSet.set
        })
      }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isAsoleacionModalOpened ? 'canvas-asoleacion fade-in':'canvas-asoleacion fade-out'}>
          {
            this.state.currentAsoleacionSet.length > 0 ?
            this.state.currentAsoleacionSet.map((images: any, index: number) => 
              <img src={images} alt="" style={{display: index === this.props.asoleacionCurrentSetIndex ? 'block':'none', willChange: 'visibility', width:'100%', height: '100%'}}/>
            ):null
          }
        </div>
      )
  }
}

export default AsoleacionImages